import { ApiService } from "./apiService";

export const analyzeProduct = async ({ images, barcode }: { images: string[], barcode: string }) => {
  return await ApiService.post(`analyzer/suggestions`, {
    images,
    barcode
  })
}

export const getProductSuggestionInfo = async (suggestionId: string) => {
  return await ApiService.get(`analyzer/suggestions/${suggestionId}/info`);
}

export const getProductSuggestionDescription = async (suggestionId: string) => {
  return await ApiService.post(`analyzer/suggestions/${suggestionId}/description`, { fields: ['definition'] });
}

export const getProductSuggestionContents = async (suggestionId: string) => {
  return await ApiService.get(`analyzer/suggestions/${suggestionId}/contents`);
}

export const getProductSuggestionUsages = async (suggestionId: string) => {
  return await ApiService.get(`analyzer/suggestions/${suggestionId}/usages`);
}

export const getProductSuggestionIngredients = async (suggestionId: string) => {
  return await ApiService.get(`analyzer/suggestions/${suggestionId}/ingredients`);
}

export const getProductSuggestionOcrText = async (suggestionId: string) => {
  return await ApiService.get(`analyzer/suggestions/${suggestionId}/ocrText`);
}

export const getProductSuggestionCategories = async (suggestionId: string) => {
  return await ApiService.get(`analyzer/suggestions/${suggestionId}/categories`);
}
